<a
  class="text-decoration-none duration-250 absolute right-5 top-5 z-50 -translate-y-20 rounded-full bg-white px-6 py-3 font-bold text-black shadow-md outline-black transition-transform ease-out focus:translate-y-0"
  href="#main-content"
  shebaSkipTo
>
  {{ 'SHARED.ACCESSIBILITY.SKIP_TO_MAIN_CONTENT' | translate }}
</a>
